import { StyleSheet as Aphrodite } from "aphrodite/no-important"

export const { StyleSheet, css } = Aphrodite.extend([
    {
        // Adding support for nesting inspired on https://github.com/Khan/aphrodite/issues/319
        selectorHandler: (selector, baseSelector, generateSubtreeStyles) => {
            if (selector[0] === "&") {
                const tag = selector.slice(1)
                const nestedTag = generateSubtreeStyles(
                    `${baseSelector} ${tag}`
                )
                return nestedTag
            } else if (selector[0] === ">") {
                const tag = selector.slice(1)
                const nestedTag = generateSubtreeStyles(
                    `${baseSelector} > ${tag}`
                )
                return nestedTag
            }
            return null
        },
    },
])
